import * as React from "react";
import { RootCauseDropdown } from "@adsk/acc-issues-common/components/input/RootCauseDropdown";
import { useRootCauseDisplayValue } from "@adsk/acc-issues-common/components/input/RootCauseDropdown/common";
import { CompactEditableFieldWrapper } from "@adsk/acc-issues-common/components/primitive/EditableFieldWrapper";
import { useFieldTestId } from "../../../utils/components/IssueFieldPresentationContext";
import { DefaultEditFieldInterface } from "./typesForFields";
import { isAttributeEditable } from "../../../utils/data/entityPermissions";
import { useTranslations } from "@adsk/acc-issues-translations";

// This Field is similar to the one in IssuesTab/TemplatesConfig/IssueTemplateDetailPanel/detail-panel-fields/...
// In case any necessary change is needed, it would be nice check on the other file as well
export const RootCauseField = ({
  issue,
  onChange,
  containerRef,
  required = false,
  viewOnly = false,
}: DefaultEditFieldInterface) => {
  const disabled = viewOnly || !isAttributeEditable(issue, "rootCauseId");
  const rootCauseFieldValue = useRootCauseDisplayValue(issue.rootCauseId);
  const { T } = useTranslations();
  const testId = useFieldTestId("root-cause-field");
  return (
    <div data-testid={testId}>
      <CompactEditableFieldWrapper
        fieldKey="rootCauseId"
        label={T.translate("issueAttributes.rootCause")}
        value={rootCauseFieldValue}
        disabled={disabled}
        containerRef={containerRef}
        renderInput={({ value, onChange: inlineEditOnChange }) => {
          return (
            <RootCauseDropdown
              selectedRootCauseId={issue.rootCauseId}
              onChange={({ rootCauseId }) => {
                // we only want `rootCauseId` from onChange,
                // but the dropdown returns the category as well, which
                // is not part of the issue object,
                // which is why we can't just pass `onChange` through
                onChange({
                  rootCauseId,
                });
                inlineEditOnChange(rootCauseId || undefined);
              }}
              defaultIsOpen={true}
              onClose={() => inlineEditOnChange(value)}
              clearable={!required}
            />
          );
        }}
        required={required}
        showDisabledReason={!viewOnly}
      />
    </div>
  );
};
